<footer>
  <div class="footer-links">
    <a routerLink="/about">About</a>
    <a routerLink="/credits">How credits work</a>
    <a routerLink="/status">Status</a>
    <a routerLink="/documentation">Documentation</a>
    <a routerLink="/become-a-provider">Run a node</a>
    <a routerLink="/terms">Terms</a>
    <a routerLink="/privacy">Privacy</a>
    @if (consent.required()) {
      <a href="" (click)="$event.preventDefault(); consent.bannerOpen.set(true)">Cookie settings</a>
    }
    @if (users.showAdmin()) {
      <a routerLink="/admin">Admin</a>
    }
  </div>
  <div>&copy; {{ year }} Digital Fluency LLC</div>
  <div class="build-info">Build: {{ buildDate | date: 'medium' }}</div>
</footer>
